import type { AttributeGroupInAttributeResponse, AttributeGroupListItem } from '@/entities/attributes';
import type { AttributeFormValues } from './validation';

/** Данные группы, которых хватает строке состава: справочник групп за ней не стоит */
export type AttributeGroupValue = AttributeFormValues['attributeGroups'][number];

/** Оставляет только то, что показывает строка состава: источники разные — сам атрибут, окно добавления и вкладка группы, хранимый вид один */
export const toAttributeGroupValue = (
  group: AttributeGroupInAttributeResponse | AttributeGroupListItem,
): AttributeGroupValue => ({
  code: group.code,
  name: group.name,
  description: group.description,
});
